module.exports = "<app-menu-principal></app-menu-principal>\r\n\r\n<div class=\"module form-module\">\r\n    <div class=\"logo-container\">\r\n        <img class=\"logo\" src=\"assets/img/eprac-logo.svg\">\r\n    </div>\r\n\r\n\r\n    <div class=\"logo-container\">\r\n        <img class=\"logo-eflow\" src=\"assets/img/eflow-logo.jpg\">\r\n    </div>\r\n    <h4><a href=\"http://www.eprac.com\" TARGET=\"_new\">www.eprac.com</a></h4>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TPL ILG/3PL_ILG/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main